export const sellingUsersEnums = ['BUYSELL', 'BROKER', 'SELLER']

export const preferencesDownArr = [
    {
        label: "Within 50 miles",
        value: "50",
    },
    {
        label: "Within 100 Miles",
        value: "100",
    },
    {
        label: "Within 150 Miles",
        value: "150",
    },
    {
        label: "Within 200 Miles",
        value: "199",
    },
    {
        label: "200+ Miles",
        value: "200",
    },
];

export const sellerBusinessCategories = [
    {
        value: "TRADITIONAL_SUPPLIER",
        label: 'I am a traditional pallet supplier.',
    },
    {
        value: "WAREHOUSE_DC",
        label: 'I am a warehouse, DC or site looking to get rid of excess pallets.',
    }, ,
    {
        value: "BROKER_RESELLER",
        label: 'I am a broker/reseller of pallets and sell via a network of pallet suppliers.',
    }
]

export const sellerBussPrefPalletTypeList = [
    {
        value: "NEWWOOD",
        label: 'New Wood Pallets',
    },
    {
        value: "RECYCLEDWOOD",
        label: 'Recycled Wood Pallets',
    },
    {
        value: "PLASTIC",
        label: 'Plastic Pallets',
    },
    {
        value: "CRATES",
        label: 'Crates',
    },
    {
        value: "TRAYS",
        label: 'Trays',
    },
    {
        value: "OTHERS",
        label: 'Other',
    }
]

export const sellerBussPrefPalletSizeList = [
    {
        value: "STRINGER_48X40",
        label: '48x40 Stringers',
    },
    {
        value: "BLOCK_48X40",
        label: '48x40 Block',
    },
    {
        value: "COMBO_48x40",
        label: '48x40 Combos',
    },
    {
        value: "SIZE_36X36",
        label: '36x36',
    },
    {
        value: "SIZE_42X42",
        label: '42x42',
    },
    {
        value: "SIZE_44X44",
        label: '44x44',
    },
    {
        value: "SIZE_48x36",
        label: '48x36',
    },
    {
        value: "SIZE_48x42",
        label: '48x42',
    },
    {
        value: "SIZE_48X48",
        label: '48x48',
    },
    {
        value: "EURO_1200x1000",
        label: 'Euro 1200x1000',
    },
    {
        value: "EURO_1200x800",
        label: 'Euro 1200x800',
    },
    {
        value: "CUSTOM",
        label: 'Custom Pallets',
    }
]

export const sellerBussPrefSpecialServicesList = [
    {
        value: "HEAT_TREATED",
        label: 'Heat Treating',
    },
    {
        value: "CHEMICAL_DIPPING",
        label: 'Chemical Dipping',
    },
    {
        value: "DROP_TRAILER",
        label: 'Drop Trailer',
    },
    {
        value: "PALLET_REMOVAL",
        label: 'Pallet Removal',
    }
]